<div style="display: flex; height:100%;">
    <ng-content></ng-content>
</div>